import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import List from '@mui/material/List';

import GenericList from '@ts-core/core/components/GenericList';

import Button from '@ts-core/components/Button';
import { SortableContainer, SortableItem } from '@ts-core/core/components/Sort';

import { Exercise } from '../../types';

import SelectedExercisesListItem from './SelectedExercisesListItem';

interface SelectedExercisesListProps {
  exercises: Exercise[];
  onRemoveExercise: (exercise: Exercise) => void;
  onRemoveAllExercises: () => void;
  onSortExercises: (from: number, to: number) => void;
}

const SelectedExercisesList = (props: SelectedExercisesListProps) => {
  const { exercises, onRemoveExercise, onRemoveAllExercises, onSortExercises } = props;
  const intl = useIntl();

  return (
    <>
      <Box display="flex" justifyContent="flex-end" width="100%" px={2} color="secondary" mb={-1}>
        <Button onClick={onRemoveAllExercises} disabled={exercises?.length === 0}>
          {intl.formatMessage({ id: 'assignment.button.cleanExercises' })}
        </Button>
      </Box>
      <List>
        <SortableContainer items={exercises} onSort={onSortExercises} renderOverlay={(exercise) => <SelectedExercisesListItem exercise={exercise} />}>
          <GenericList
            items={exercises}
            renderItem={(index, exercise) => {
              if (!exercise) {
                return <span />;
              }
              return (
                <SortableItem key={exercise.id} id={exercise.id} minHeight={46}>
                  <SelectedExercisesListItem exercise={exercise} onRemoveExercise={onRemoveExercise} />
                </SortableItem>
              );
            }}
          />
        </SortableContainer>
      </List>
    </>
  );
};

export default SelectedExercisesList;
